import { useEffect, useState } from 'react';

const ITEM = ({ item, index, handleDeleteItem, handleAimBlur, handleNameBlur, isCompleted }) => {
	const [aimValue, setAimValue] = useState(item.aim || 0)
	const [nameValue, setNameValue] = useState(item.name || '')
	useEffect(() => { setAimValue(item.aim || 0); setNameValue(item.name || ''); }, [item.aim, item.name]);

	if (!item || !item.name) {
		return null
	}

	return (
		<tr>
			<td>
				<input
					type="text"
					aria-label={`Scorecard item ${index + 1} name`}
					name={`roundup_prepare_item_name_${index}`}
					value={nameValue}
					onChange={(e) => setNameValue(e.target.value)}
					onBlur={() => handleNameBlur(index, nameValue)}
					disabled={isCompleted}
				/>
			</td>
			<td>
				<input
					type="number"
					min="0"
					aria-label={`Aim for ${item.name}`}
					name={`roundup_prepare_item_score_${item.name}_aim`}
					placeholder={item.aim}
					value={aimValue}
					onChange={(e) => setAimValue(e.target.value)}
					onBlur={() => handleAimBlur(index, aimValue)}
					disabled={isCompleted}
				/>
			</td>
			<td>
				{!isCompleted && (
					<button onClick={handleDeleteItem}>DELETE</button>
				)}
			</td>
		</tr>
	);
};
export default ITEM
